"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SidebarItem = _interopRequireDefault(require("react-rainbow-components/components/SidebarItem"));

var _reactRouterDom = require("react-router-dom");

var SideBarOption = function SideBarOption(props) {
  var className = props.className,
      style = props.style,
      icon = props.icon,
      selectedIcon = props.selectedIcon,
      name = props.name,
      label = props.label,
      path = props.path,
      exact = props.exact;
  var history = (0, _reactRouterDom.useHistory)();
  var match = (0, _reactRouterDom.useRouteMatch)(path);
  var isSelected = match && (!exact || match.isExact);
  var actualIcon = isSelected && selectedIcon ? selectedIcon : icon;

  var handleClick = function handleClick(event) {
    event.preventDefault();
    history.push(path);
  };

  return /*#__PURE__*/_react["default"].createElement(_SidebarItem["default"], {
    className: className,
    style: style,
    icon: actualIcon,
    name: name,
    label: label,
    onClick: handleClick
  });
};

SideBarOption.propTypes = {
  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object,

  /** The icon displayed in the SidebarItem. It must be a svg icon or a font icon. */
  icon: _propTypes["default"].node,

  /** The icon displayed in the SidebarItem when selected. It must be a svg icon or a font icon. */
  selectedIcon: _propTypes["default"].node,

  /** A unique identifier for the navigation item. */
  name: _propTypes["default"].string,

  /** The text to show if it is passed. */
  label: _propTypes["default"].node,

  /** The path to navigate to when the item is clicked. */
  path: _propTypes["default"].string,

  /** When true, will only match if the path matches the location.pathname exactly */
  exact: _propTypes["default"].bool
};
SideBarOption.defaultProps = {
  className: undefined,
  style: undefined,
  icon: undefined,
  selectedIcon: undefined,
  name: undefined,
  label: undefined,
  path: undefined,
  exact: false
};
var _default = SideBarOption;
exports["default"] = _default;